'use memo'
import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { AgxBadge } from '@urbanx/agx.ui-components2'
import { getDueDateBadgeState } from 'utils/tasks'

interface TaskDueCellProps {
  task: AutopilotTaskDto
}

const TaskDueCell = ({ task }: TaskDueCellProps) => {
  const { dueDate } = task

  const dueDateStr = dueDate as unknown as string

  if (!dueDateStr) return null
  const badge = getDueDateBadgeState(dueDateStr, task.isCompleted ?? false)

  if (badge.type === 'highlighted') {
    return (
      <AgxBadge
        type="highlighted"
        colour={badge.color}
        size="md"
        text={badge.text}
        highlightText={badge.highlightText}
      />
    )
  }

  return (
    <AgxBadge
      type="colourfill"
      colour={badge.color}
      size="md"
      text={badge.text}
    />
  )
}

export default TaskDueCell
